import React, {useEffect, useState} from 'react'
import DataTable from "react-data-table-component";
import {doc, getDoc, updateDoc} from "firebase/firestore";
import {getDb} from 'util/Constants';
import {useParams} from 'react-router-dom';
import {Button, Card, Col, Container, Form, Input, Row, Spinner} from "reactstrap";
import DatePicker from "react-datepicker";
import {NotificationManager} from 'react-notifications';
import EditArtwork from 'views/assessment/editArtWork';

function SettingsAdmin() {
    const [departments, setDepartments] = useState([]);
    const [regions, setRegions] = useState([]);
    const [editing, setEditing] = useState(null);
    const [editingDepartment, setEditingDepartment] = useState(null);
    const [load, setLoad] = useState(true);
    const [startTime, setStartTime] = useState(null)
    const [endTime, setEndTime] = useState(null);
    const [loaderDate, setLoaderDate] = useState(false);
    const [loaderCandidateFlow, setLoaderCandidateFlow] = useState(false);
    const [registrationFields, setRegistrationFields] = useState([]);
    const [loading, setLoading] = useState(null);
    const [artWork, setArtWork] = useState(null);
    const [cf_startTime, setCf_StartTime] = useState(null);
    const [cf_endTime, setCf_EndTime] = useState(null);

    const {eventId} = useParams()
    const db = getDb();

    useEffect(() => {
        getEvent().then((e) => {
            setRegistrationFields(e.registrationFields);
            setDepartments(e.departments && e.departments)
            if (e.startTime && e.endTime) {
                setStartTime(new Date(e.startTime.seconds * 1000));
                setEndTime(new Date(e.endTime.seconds * 1000));
            }
            if (e.cf_startTime && e.cf_endTime) {
                setCf_StartTime(new Date(e.cf_startTime.seconds * 1000));
                setCf_EndTime(new Date(e.cf_endTime.seconds * 1000));
            }
            setRegions(e.region && e.region)
            console.log("event", e)
            setArtWork({
                introVideo: e.introVideo || null,
                companyLogo: e.companyLogo || null
            })
            setLoad(false);
        })
    }, [])


    const getEvent = async () => {
        const docRef = doc(db, "Events", eventId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            console.log(docSnap.data(), "Event data");
            return docSnap.data();
        }
    }

    const handleEndTime = (date) => {
        setEndTime(date)
    }
    const handleStartTime = (date) => {
        setStartTime(date)
    }
    const handleCf_EndTime = (date) => {
        setCf_EndTime(date)
    }
    const handleCf_StartTime = (date) => {
        setCf_StartTime(date)
    }

    const handleSubmit = async () => {
        if (startTime > endTime) {
            NotificationManager.error("Invalid Dates");
            return;
        }
        if (startTime && endTime) {
            setLoaderDate(true)
            const docRef = doc(getDb(), "Events", eventId);
            await updateDoc(docRef, {
                startTime: startTime,
                endTime: endTime
            });
            setLoaderDate(false)
            NotificationManager.success("Saved Dates Successfully");

        } else {
            NotificationManager.error("Please Select Dates");
        }
    }

    const handleCandidateFlowSubmit = async () => {
        console.log(cf_startTime, cf_endTime, "Candidate Flow Dates");
        if (!cf_startTime || !cf_endTime) {
            NotificationManager.error("Please Select both Dates");
            return;
        }
        setLoaderCandidateFlow(true);
        try {
            const docRef = doc(getDb(), "Events", eventId);
            await updateDoc(docRef, {
                cf_startTime: cf_startTime,
                cf_endTime: cf_endTime
            });
            setLoaderCandidateFlow(false);
            NotificationManager.success("Candidate Flow Date Saved Successfully");
        } catch (error) {
            console.error("Error saving candidate flow date:", error);
            setLoaderCandidateFlow(false);
            NotificationManager.error("Failed to save candidate flow date");
        }
    }

    return (
        <div>
            <Container fluid>
                <Row>
                    {registrationFields.includes("department") &&
                        <Col className=' mb-3' md={"6"}>
                            <div className="d-flex justify-content-between">
                                <h1 className="mb-0 custom-font letterSpacing">Departments</h1>
                                {/*<Button color="primary" onClick={difficultyToggle}>Add Difficulty</Button>*/}
                            </div>
                            <Card>
                                <DataTable
                                    columns={[{
                                        name: 'Department',
                                        selector: row => row,
                                        cell: row => (
                                            <div className="w-100">
                                                {
                                                    editingDepartment === row ?
                                                        <Form
                                                            className="d-flex justify-content-around align-items-center"
                                                            onSubmit={async e => {
                                                                setLoading(row);
                                                                e.preventDefault();

                                                                let _index = -1;
                                                                const _data = departments.map((_row, i) => {
                                                                    console.log(_row);
                                                                    if (_row === row) {
                                                                        _row = e.target[0].value;
                                                                        _index = i;
                                                                    }
                                                                    return _row;
                                                                });

                                                                if (_index >= 0) {


                                                                    // await _data[_index].save();
                                                                    const docRef = doc(getDb(), "Events", eventId);
                                                                    await updateDoc(docRef, {
                                                                        departments: _data
                                                                    });
                                                                }

                                                                setDepartments(_data);

                                                                setLoading(null);
                                                                setEditingDepartment(null);
                                                            }}>
                                                            <Input bsSize="sm" className="form-control-alternative"
                                                                   type="text" name={row}
                                                                   defaultValue={row} required
                                                                   style={{maxWidth: '75%'}}/>
                                                            <Button
                                                                disabled={loading === row}
                                                                className="px-2 ml-2 mr-0"
                                                                color="success"
                                                                size="sm"
                                                                type="submit"
                                                            >
                                                                {
                                                                    loading === row ?
                                                                        <Spinner size="sm" color="light"/> :
                                                                        <i className="fas fa-check"/>
                                                                }
                                                            </Button>
                                                        </Form> :
                                                        <span>{row}</span>
                                                }
                                            </div>
                                        )
                                    },
                                        {
                                            name: '',
                                            minWidth: '10%',
                                            maxWidth: '15%',
                                            selector: row => null,
                                            cell: row => (
                                                <div>
                                                    <Button
                                                        color={editingDepartment === row ? "danger" : "default"}
                                                        size="sm"
                                                        onClick={() => editingDepartment === row ? setEditingDepartment(null) : setEditingDepartment(row)}
                                                    >
                                                        {
                                                            editingDepartment === row ?
                                                                <i className="fas fa-times"/> :
                                                                <i className="fas fa-pencil-alt"/>
                                                        }
                                                    </Button>
                                                </div>
                                            )
                                        }]}
                                    data={departments}

                                    progressPending={load}
                                />
                            </Card>
                        </Col>
                    }
                    {registrationFields.includes("region") &&
                        <Col className=' mb-3' md={"6"}>
                            <div className="d-flex justify-content-between">
                                <h1 className="mb-0 custom-font letterSpacing">Regions</h1>
                                {/*<Button color="primary" onClick={difficultyToggle}>Add Difficulty</Button>*/}
                            </div>
                            <Card>
                                <DataTable
                                    columns={[{
                                        name: 'Region',
                                        selector: row => row,
                                        cell: row => (
                                            <div className="w-100">
                                                {
                                                    editing === row ?
                                                        <Form
                                                            className="d-flex justify-content-around align-items-center"
                                                            onSubmit={async e => {
                                                                setLoading(row);

                                                                e.preventDefault();

                                                                let _index = -1;
                                                                const _data = regions.map((_row, i) => {
                                                                    console.log(_row);
                                                                    if (_row === row) {
                                                                        _row = e.target[0].value;
                                                                        _index = i;
                                                                    }
                                                                    return _row;
                                                                });

                                                                if (_index >= 0) {


                                                                    // await _data[_index].save();
                                                                    const docRef = doc(getDb(), "Events", eventId);
                                                                    await updateDoc(docRef, {
                                                                        region: _data
                                                                    });
                                                                }

                                                                setRegions(_data);

                                                                setLoading(null);
                                                                setEditing(null);
                                                            }}>
                                                            <Input bsSize="sm" className="form-control-alternative"
                                                                   type="text" name={row}
                                                                   defaultValue={row} required
                                                                   style={{maxWidth: '75%'}}/>
                                                            <Button
                                                                disabled={loading === row}
                                                                className="px-2 ml-2 mr-0"
                                                                color="success"
                                                                size="sm"
                                                                type="submit"
                                                            >
                                                                {
                                                                    loading === row ?
                                                                        <Spinner size="sm" color="light"/> :
                                                                        <i className="fas fa-check"/>
                                                                }
                                                            </Button>
                                                        </Form> :
                                                        <span>{row}</span>
                                                }
                                            </div>
                                        )
                                    },
                                        {
                                            name: '',
                                            minWidth: '10%',
                                            maxWidth: '15%',
                                            selector: row => null,
                                            cell: row => (
                                                <div>
                                                    <Button
                                                        color={editing === row ? "danger" : "default"}
                                                        size="sm"
                                                        onClick={() => editing === row ? setEditing(null) : setEditing(row)}
                                                    >
                                                        {
                                                            editing === row ?
                                                                <i className="fas fa-times"/> :
                                                                <i className="fas fa-pencil-alt"/>
                                                        }
                                                    </Button>
                                                </div>
                                            )
                                        }]}
                                    data={regions}
                                    progressPending={load}
                                />
                            </Card>
                        </Col>
                    }
                    <Col className='mb-3' md={"6"}>
                        {/*<div className="d-flex justify-content-between">*/}
                        <h1 className="mb-0 custom-font letterSpacing">Game Start and End Time</h1>
                            {/*<Button color="primary" onClick={difficultyToggle}>Add Difficulty</Button>*/}
                        {/*</div>*/}

                        <div className='d-flex justify-content-between align-items-baseline'>
                            <DatePicker
                                showIcon
                                className='assessment-input w-100 pl-5'
                                selected={startTime}
                                onChange={handleStartTime}
                                selectsStart
                                startDate={startTime}
                                endDate={endTime}
                                dateFormat="dd-MMM-yyyy  hh:mm aa"
                                placeholderText="Select Start time"
                                minDate={Date.now()}
                                showTimeSelect
                            />
                            <span className="mx-4 font-weight-bold text-dark">to</span>
                            <DatePicker
                                showIcon
                                className='assessment-input w-100 pl-5'
                                selected={endTime}
                                onChange={handleEndTime}
                                selectsStart
                                startDate={startTime}
                                endDate={endTime}
                                dateFormat="dd-MMM-yyyy  hh:mm aa"
                                placeholderText="Select End time"
                                minDate={startTime}
                                showTimeSelect
                            />
                        </div>
                        <Button color='success' size="sm" onClick={handleSubmit} className='mt-3'>

                            {!loaderDate ?
                                "Save" : <Spinner size="sm" color="light"/>}
                        </Button>
                    </Col>
                </Row>

                <Row>
                    <Col className='mb-3' md={"6"}>
                        {/*<div className="d-flex justify-content-between">*/}
                        <h1 className="mb-0 custom-font letterSpacing">Candidate Flow Start and End Time</h1>
                        {/*</div>*/}

                        <div className='d-flex justify-content-between align-items-baseline'>
                            <DatePicker
                                showIcon
                                className='assessment-input w-100 pl-5'
                                selected={cf_startTime}
                                onChange={handleCf_StartTime}
                                selectsStart
                                startDate={cf_startTime}
                                endDate={cf_endTime}
                                dateFormat="dd-MMM-yyyy  hh:mm aa"
                                placeholderText="Select Start time"
                                minDate={Date.now()}
                                showTimeSelect
                            />
                            <span className="mx-4 font-weight-bold text-dark">to</span>
                            <DatePicker
                                showIcon
                                className='assessment-input w-100 pl-5'
                                selected={cf_endTime}
                                onChange={handleCf_EndTime}
                                selectsStart
                                startDate={cf_startTime}
                                endDate={cf_endTime}
                                dateFormat="dd-MMM-yyyy  hh:mm aa"
                                placeholderText="Select End time"
                                minDate={cf_startTime}
                                showTimeSelect
                            />
                        </div>
                        <Button color='success' size="sm" onClick={handleCandidateFlowSubmit} className='mt-3'>
                            {!loaderCandidateFlow ?
                                "Save" : <Spinner size="sm" color="light"/>}
                        </Button>
                    </Col>
                </Row>

                {eventId && artWork &&
                    <Row>
                        <Col sm={12} lg={6}>
                            <h1 className="mb-0 custom-font letterSpacing">Customize Artwork</h1>
                            <EditArtwork eventId={eventId} artWork={artWork}/>
                        </Col>
                    </Row>
                }


            </Container>

        </div>
    )
}

export default SettingsAdmin




